import template from './trip-item-rail-tickets-question.html';

const DIRECTIVE_NAME = TripItemRailTicketsQuestion.DIRECTIVE_NAME = 'ktTripItemRailTicketsQuestion';
export default function TripItemRailTicketsQuestion() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: TripItemRailTicketsQuestionController,
        controllerAs: '$ctrl',
        scope: {
            areTicketsCollected: `=${DIRECTIVE_NAME}`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };

}

export function TripItemRailTicketsQuestionController() {
    const vm = this;

    Object.assign(vm, {
        $onInit,
        hasError,
    });

    function $onInit() {
    }

    function hasError() {
        return vm.form.$submitted
            && vm.form.$invalid;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-cancellation/trip-item-rail-tickets-question/trip-item-rail-tickets-question-component.js